
export const DEFAULT_FORMAT = 'YYYY-MM-DD'
export const SIMPLE_DTTM_FORMAT = 'YYYYMMDDHHmmss'
// export const SIMPLE_DATE_FORMAT = 'YYYYMMDD'
// export const SIMPLE_YEAR_MONTH_FORMAT = 'YYYYMM'

export const DTTM_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DTTM_FULL_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS'
export const DTTM_MIN_FORMAT = 'YYYY-MM-DD HH:mm'
export const DTTM_MDHMS_FORMAT = 'MM-DD HH:mm:ss'

export const DATE_TIME_NO_YEAR_AND_SECOND_FORMAT = 'MM-DD HH:mm'
// export const TIME_WITHOUT_DATE_FORMAT = 'HH:mm'
// export const TIME_MINUTE_FORMAT = 'mm'
// export const TIME_HOUR_FORMAT = 'YYYY-MM-DD HH'
export const YEAR_MONTH_FORMAT = 'YYYY-MM'

export const LAYOUT = {
  GUTTER: 24,
  GRID: {
    xl: { span: 12, offset: 6 },
    lg: { span: 12, offset: 6 },
    md: { span: 16, offset: 4 },
    sm: { span: 20, offset: 2 },
    xs: 24
  },
  GRID2: {
    xl: 12,
    lg: 12,
    md: 24,
    sm: 24,
    xs: 24
  },
  GRID3: {
    xl: 8,
    lg: 8,
    md: 12,
    sm: 24,
    xs: 24
  },
  GRID4: {
    xl: 6,
    lg: 6,
    md: 12,
    sm: 24,
    xs: 24
  },
  TABLE_ATTR: {
    stripe: true
  }
}

export const PAGING = {
  CURRENT: 1,
  PAGE_SIZE: 10
}

export const TIMEOUT = {
  MODAL_FORM: 200,
  BUTTON_SUBMITTING: 1000,
  CLOSE_MODAL_AFTER_UPDATED: 100
}

export const UPDATED_ACTION = {
  ADD: 'ADD',
  UPDATE: 'UPDATE',
  REMOVE: 'REMOVE'
}

export const BASE_FONT_SIZE = 32
export const BASE_WINDOW_HEIGHT = 1080
export const BASE_WINDOW_WIDTH = 3200
export const TAXI = 'TAXI' // 巡游出租车
export const PHV = 'PHV' // 巡游出租车
export const ADAPT_WIDTH = 992 // 前端自适应的宽度js值
export const ADAPT_LABEL_WIDTH = 1200 // 前端自适应的label标签宽度js值,
export const DEFAULT_COST_COLUMN_PARENT_ID = '001000' // rsp_cost_column的节点(父节点都是'工程成本栏'), 在rsp_column的默认父节点
export const STATUS = {
  ACTIVE: 'A',
  INACTIVE: 'I'
}
export const DEFAULT_STATUS = STATUS.ACTIVE
export const IND = {
  YES: 'Y',
  NO: 'N'
}
export const DEFAULT_IND = IND.YES
export const IND_USED = {
  YES: 'Y',
  NO: 'N'
}
export const INCOME_TYPE = {
  PROJ_FUND: 'PROJ_FUND',
  OTH_INCOME: 'OTH_INCOME',
  PROJ_OUT_VAT: 'PROJ_OUT_VAT',
  TRANSFER: 'TRANSFER'
}
export const DEFAULT_INCOME_TYPE = INCOME_TYPE.TRANSFER

export const RPT_STATUS = {
  TODO: 'TODO',
  IN_DEV: 'IN_DEV', // 进行中
  // PAUSE: '暂停',
  DONE: 'DONE' // 已完工结算
}
// export const STATUS_TODO = 'TODO'
export const ENTITY_STATUS = {
  // TODO: '未开始',
  IN_DEV: 'IN_DEV', // 进行中
  // PAUSE: '暂停',
  DONE: 'DONE' // 已完工结算
}
// export default {
//   STATUS: {
//     ACTIVE: 'A',
//     INACTIVE: 'I'
//   },
//   DEFAULT_STATUS: 'A',
//   IND: {
//     YES: 'Y',
//     NO: 'N'
//   },
//   DEFAULT_IND: 'Y',
//   IND_USED: {
//     YES: 'Y',
//     NO: 'N'
//   },
//   INCOME_TYPE: {
//     PROJ_FUND: 'PROJ_FUND',
//     OTH_INCOME: 'OTH_INCOME',
//     PROJ_OUT_VAT: 'PROJ_OUT_VAT',
//     TRANSFER: 'TRANSFER'
//   },
//   DEFAULT_INCOME_TYPE: 'TRANSFER',
//   // IND_USED_ALREADY: 'Y',
//   END: null
// }



// WEBPACK FOOTER //
// ./src/constant/index.js